<template>
  <div class="home">
    <div class="top">
      <tabs @tabChange="initContent" :list="list">
        <div slot="current">
          <!-- <div class="">
            <div class="selects" @click="showPicker = true">
              <h3 class="">
                {{ texts }}
              </h3>
              <van-icon class="icons" name="arrow-down" color="#489FFF" />
            </div>
          </div> -->
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              value-key="roomName"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <div style="height: 20px"></div>
          <van-pull-refresh v-model="isLoading1" @refresh="onRefresh1">
            <div class="autoFixed">
              <van-list>
                <van-cell
                  v-for="(item, index) in needAuditing"
                  :key="index"
                  style="margin-bottom: 10px; padding: 0; border-radius: 5px"
                >
                  <div class="main">
                    <span class="roomName">{{ item.roomName }}</span>
                    <div class="history-left" style="margin-top: 20px">
                      <div class="history-item">
                        <span>会议时段：</span>
                        <span>{{ item.useDate }}</span>
                        <span style="margin-left:10px">{{moonState[item.timeStatus]}}</span>
                      </div>
                      <div class="history-item">
                        <span>会议用途：</span>
                        <span>{{ item.purpose }}</span>
                      </div>
                      <div class="history-item">
                        <span>联系人：</span>
                        <span>{{ item.personName }}</span>
                      </div>
                      <div class="history-item">
                        <span>联系电话：</span>
                        <span>{{ item.personPhone }}</span>
                      </div>
                      <div class="history-item" v-if="isShowAgree">
                        <span>预约时间：</span>
                        <span>{{ item.createTime }}</span>
                      </div>
                      <div style="display: none" ref="reasons">
                        <div class="history-item flexLayout">
                          <span>审核意见：</span>
                          <div>
                            <van-radio-group
                              v-model="multiObj[item.id]"
                              direction="horizontal"
                              @change="getAgreeStatus($event,index)"
                            >
                              <van-radio :name="'on-' + item.id"
                                >同意</van-radio
                              >
                              <van-radio :name="'off-' + item.id"
                                >拒绝</van-radio
                              >
                            </van-radio-group>
                          </div>
                        </div>
                        <div
                          style="
                            border: 1px solid #eee;
                            padding: 0 10px;
                            margin-bottom: 10px;
                            width: 100%;
                            box-sizing: border-box;
                            display:none
                          "
                          ref='selfText'
                        >
                          <van-field
                            v-model="messages[index]"
                            rows="2"
                            autosize
                            label="意见"
                            type="textarea"
                            maxlength="100"
                            placeholder="请输入意见"
                            show-word-limit
                          />
                          
                         
                        </div>
                         <van-button
                            plain
                            type="info"
                            size="small"
                            style="margin-bottom:10px"
                            @click="submitAudit(item,index)"
                            >提交
                          </van-button>
                      </div>
                    </div>
                    <!-- 审核中 -->
                    <div class="hisotry-right">
                      <img
                        v-if="item.apptStatus == 1"
                        src="../../assets/auditing/daishenhe.png"
                      />
                      <!-- 同意 -->
                    </div>

                    <van-button
                      plain
                      type="info"
                      size="small"
                      class="userBtn"
                      ref="sureBtn"
                      @click="showCurrentReason(index)"
                      >审核
                    </van-button>
                    <van-button
                      plain
                      type="info"
                      ref="cancleBtn"
                      size="small"
                      class="userBtn"
                      style="display: none"
                      @click="onCancel(index)"
                      >取消
                    </van-button>
                  </div>
                </van-cell>
                <!-- 加载的内容-->
              </van-list>
            </div>
          </van-pull-refresh>
        </div>

        <!-- =================历史记录-===================== -->
        <div slot="history">
          <div class="currentPre" @click="show = true">
            <div style="width: 80%; text-align: center">
              <div v-if="!isShow" class="place">
                <span>开始时间</span>
                <span>-</span>
                <span>结束时间</span>
              </div>
              <div v-else class="fontss">{{ date }}</div>
            </div>

            <van-icon name="calendar-o" />
          </div>
          <van-calendar
            allow-same-day
            v-model="show"
            type="range"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="calendarConfirm"
          />
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="autoFixed">
              <van-list>
                <van-cell
                  v-for="(item, index) in histroyLists"
                  :key="index"
                  style="margin-bottom: 10px; padding: 0; border-radius: 5px"
                >
                  <div class="main">
                    <span class="roomName">{{ item.roomName }}</span>
                    <div class="history-left" style="margin-top: 20px">
                      <div class="history-item">
                        <span>会议时段：</span>
                        <span>{{ item.useDate }}</span>
                        <span style="margin-left: 10px">{{
                          maps[item.timeStatus]
                        }}</span>
                      </div>
                      <div class="history-item">
                        <span>会议用途：</span>
                        <span>{{ item.purpose }}</span>
                      </div>
                      <div class="history-item">
                        <span>联系人：</span>
                        <span>{{ item.personName }}</span>
                      </div>
                      <div class="history-item">
                        <span>联系电话：</span>
                        <span>{{ item.personPhone }}</span>
                      </div>
                      <div class="history-item">
                        <span>预约时间：</span>
                        <span>{{ item.createTime }}</span>
                      </div>
                       <div class="history-item">
                        <span>审核时间：</span>
                        <span>{{ item.updateTime }}</span>
                      </div>
                      <div class="history-item" v-if="item.apptStatus == 3">
                          <span>拒绝理由：</span>
                          <span style="color:red">{{item.refuseReason}}</span>
                      </div>
                    </div>
                    <!-- 审核中 -->
                    <div class="hisotry-right cc">
                      <!-- 同意 -->
                      <img
                        v-if="item.apptStatus == 2"
                        src="../../assets/auditing/wancheng.png"
                        alt=""
                      />
                      <!-- 驳回 -->
                      <img
                        v-if="item.apptStatus == 3"
                        src="../../assets/meeting/bohui.png"
                        alt=""
                      />
                    </div>
                  </div>
                </van-cell>
                <!-- 加载的内容-->
              </van-list>
            </div>
          </van-pull-refresh>
        </div>
      </tabs>
    </div>
  </div>
</template>

<script>
import tabs from "../../components/tabs.vue";
import { getAuditLists, getHistoryAuditingLists,preAudting } from "../../apis/api";
import { Toast, Dialog } from "vant";
import { formatTime, getCurrentDate } from "../../utils/index";
export default {
  data() {
    return {
      
      isShowtuifang: false,
      messages: {},
      show: false,
      fileList: [],
      date: "",
      value: "",
      maps: ["上午", "中午", "下午"],
      texts: "请选择会议楼",
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 0, 31),
      list: [
        {
          name: "待审核",
          type: "current",
        },
        {
          name: "历史审核",
          type: "history",
        },
      ],
      isLoading1: false,
      isLoading: false,
      loading: false,
      isShow: false,
      roomLists: [],
      level1: "",
      showConfirm: false,
      columns: [1, 2, 3],
      showPicker: false,
      infos: [],
      histroyLists: [],
      beginTime: "",
      endTime: "",
      date: "",
      pageSize: 10,
      pageNo: 1,
      currentDates: "",
      currentWeeks: 0,
      agree: "",
      isShowAgree: false,
      needAuditing: [],
      multiObj: {},
      isAgree:0,
      moonState:['上午','下午','晚上']
    };
  },
  beforeDestroy() {
    clearInterval(this.setTimer);
    this.setTimer = null;
  },
  mounted() {
    document.title = "会议室审核";

    let _this = this;

    this.getCurrentLists();
  },

  methods: {
    getAgreeStatus(e, index) {
      console.log(e, index, 123);
      if(e.split('-')[0]=='on'){
          //同意
        //   隐藏reason
        this.$refs.selfText[index].style.display = 'none'
        this.isAgree = 1
      }else{
           this.$refs.selfText[index].style.display = 'block'
            this.isAgree = 0;
      }
    },
    getCurrentLists() {
      getAuditLists({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.needAuditing = res.result.records;
        this.isLoading1 = false;
      });
    },
    submitAudit(item,index) {
        // console.log(this.$(this.$refs.selfText[index]))
        this.$nextTick(()=>{
            console.log()
        })
    //   console.log(item,messages);
    //   根据勾选的radio
       preAudting({
              checkStatus:this.isAgree,
             //0拒绝，1同意
              appointmentId:item.id,
              refuseReason:this.isAgree==0?this.$(this.$refs.selfText[index]).find('textarea').val():''
          }).then(res=>{
              Toast('操作成功')
              this.$router.go(0)
          })
    

    },

    initContent(value) {
      console.log("init", value);
      if (value == 0) {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getCurrentLists();
      } else {
        getHistoryAuditingLists({
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }).then((res) => {
          console.log("history", res);
          if (res.result.records.length == 0) {
            Toast("暂无数据");
          }else{
              this.histroyLists = res.result.records;
          }
        });
      }
    },
    onConfirm(e) {
      console.log(e);
      this.showPicker = false;
      this.texts = e.roomName;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    calendarConfirm(e) {
      console.log(e);
      this.show = false;
      const [start, end] = e;
      this.show = false;
      this.isShow = true;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.beginTime = this.formatDate(start);
      this.endTime = this.formatDate(end);
    },
    showCurrentReason(index) {
    this.isAgree = 0;
      this.$refs.reasons[index].style.display = "block";
      this.$refs.cancleBtn[index].style.display = "block";
      this.$refs.sureBtn[index].style.display = "none";
    },

    onCancel(index) {
      this.$refs.reasons[index].style.display = "none";
      this.$refs.cancleBtn[index].style.display = "none";
      this.$refs.sureBtn[index].style.display = "block";
    },
    onChange() {},
    onRefresh1() {
      this.getCurrentLists();
    },
    onRefresh() {
      this.beginTime = this.beforeDay(1);

      this.endTime = formatTime();
      this.pageSize = 10;
      this.pageNo = 1;
      // this.getHistoryLists();
      getHistoryAuditingLists({
        entryTime: this.beginTime,
        leaveTime: this.endTime,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.histroyLists = res.result.records;
      });
    },
  },
  components: {
    tabs,
  },
};
</script>

<style lang="less" scoped>
.labels {
  width: 80px;
  //   border-right: 1px solid #eee;
  p {
    width: 100%;
    text-align: center;
    height: 80px;
    line-height: 80px;
    border-bottom: 1px solid #eee;
  }
  p:last-child {
    //   border-bottom: none;
  }
}
.autoFlex {
  display: flex;
}
.roomList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-left: 1px solid #eee;
  flex: 1;
  .room {
    width: 13.9%;
    border-right: 1px solid #eee;
    height: 80px;
    border-bottom: 1px solid #eee;
    text-align: center;
    line-height: 80px;
  }
  .room:nth-child(7n) {
    border-right: none;
  }
}
.level_room {
  h4 {
    width: 100%;
    text-align: center;
    color: #489fff;
    border-top: 1px solid #489fff;
    border-bottom: 1px solid #489fff;
    margin: 0;
    height: 80px;
    line-height: 80px;
    font-size: 40px;
    // margin-top: 20px;
  }
}
.lists {
  display: flex;
  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #eee;
  }
  .lasts {
    border: none;
  }
}
.borders {
  border: 1px solid #eee;
  margin: 0 auto;
  margin-left: 30px;
  // padding-top: 10px;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  // padding: 10px 20px;
  .left {
    border-right: 1px solid #eee;
    padding: 20px 10px;
    padding-bottom: 0;
    width: 9.5%;
  }
  .right {
    border-left: 1px solid #eee;
    padding: 20px 10px;
    padding-bottom: 0;
    width: 9.5%;
  }
  .arrows {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    img {
      width: 40px;
      height: 40px;
    }
  }
}
.currentPre {
  width: 80%;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.selects {
  width: 50%;
  margin: 0 auto;
  border: 2px solid #489fff;
  border-radius: 80px;
  margin-top: 20px;
  height: 60px;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  position: relative;
}
.icons {
  font-size: 32px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}
.selects h3 {
  font-size: 28px;
  height: 60px;
  line-height: 60px;
  margin: 0;
  color: #489fff;
  text-align: center;
  // color: ;
}
.autoFixed {
  padding: 30px;
  padding-bottom: 0;
  padding-top: 0;
  position: relative;

  .userBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;

    background: none;
    border-radius: 5px;
    color: #4597ff;
  }

  .main {
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    padding: 30px;
    box-sizing: border-box;
    position: relative;
    padding-top: 60px;
    padding-bottom: 0;

    // margin-bottom: 20px;
    .roomName {
      position: absolute;
      left: 20px;
      top: 20px;
      color: #64b0ff;
      font-weight: bold;
    }

    .hisotry-right {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      img {
        width: 150px;
        height: 150px;
      }
    }

    .history-item {
      margin-bottom: 20px;

      span {
        font-size: 28px;
        color: #333;
      }
    }
  }
}

.currentPre {
  display: flex;
  height: 80px;
  align-items: center;
  width: 80%;
  margin: 0 auto;
  border: 2px solid #7ab6f5;
  margin-top: 20px;
  border-radius: 40px;
  justify-content: center;
  background-color: #ffffff;
  margin-bottom: 20px;

  span {
    font-size: 32px;
    color: #7ab6f5;
    margin-right: 20px;
  }

  .fontss {
    font-size: 32px;
    color: #7ab6f5;
    margin-right: 20px;
  }

  i {
    font-size: 40px;
    color: #7ab6f5;
  }
}
.place {
  display: flex;
  align-items: center;
  justify-content: center;
}
.home {
  background: #f7f7f7;
  min-height: 100vh;
}
.demo {
  display: flex;
  align-items: center;
}
.demo span {
  font-size: 24px;
}
.disableds {
  background: #d0d0d0;
}
.flexLayout {
  display: flex;
  align-items: center;
}
.cc img{
    width: 150px;
    height: 130px!important;
}
</style>
